import { render, staticRenderFns } from "./MenuLeftIcon.vue?vue&type=template&id=80a00dce&scoped=true"
import script from "./MenuLeftIcon.vue?vue&type=script&lang=js"
export * from "./MenuLeftIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuLeftIcon.vue?vue&type=style&index=0&id=80a00dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a00dce",
  null
  
)

export default component.exports